import { render, staticRenderFns } from "./ExportCommon.vue?vue&type=template&id=c2648068"
import script from "./ExportCommon.vue?vue&type=script&lang=js"
export * from "./ExportCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2648068')) {
      api.createRecord('c2648068', component.options)
    } else {
      api.reload('c2648068', component.options)
    }
    module.hot.accept("./ExportCommon.vue?vue&type=template&id=c2648068", function () {
      api.rerender('c2648068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/import-export/ExportCommon.vue"
export default component.exports